<script>
  export default {
    name: 'SelectSituacaoVeiculo',
    props: {
      value: {
        required: true
      }
    },
    data () {
      return {
        data: [
          {value: 'R', label: 'Recuperável'},
          {value: 'I', label: 'Sucata'}
        ]
      }
    },
    computed: {
      model: {
        get () {
          return this.value === null ? '' : this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    }
  }
</script>

<template>
  <div class="form-group">
    <label class="col-lg-2 control-label">Situação do Veículo</label>
    <div class="col-lg-10">
      <select class="form-control w-auto w-full-xs" v-model="model" required>
        <option :value="item.value" v-for="item in data" :key="item.value">{{item.label}}</option>
      </select>
    </div>
  </div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectSituacaoVeiculo.vue?6690df57